<template>
  <div>
    <h6
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
    >
      {{ isNaN(sonuc) == true ? 0 : sonuc }}
    </h6>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VALUE: "",
      sonuc: ""
    };
  },
  created() {
    this.VALUE = this.params.value;

    let Sonuc1 = 0.0,
      Sonuc2 = 0.0,
      DepoAdt = 0;

    if (
      parseFloat(this.params.data.KRITIKSTOK) >
      parseFloat(this.params.data.QDEPOT)
    ) {
      DepoAdt =
        parseFloat(this.params.data.KRITIKSTOK) -
        parseFloat(this.params.data.QDEPOT);
    } else {
      DepoAdt = 0;
    }

    Sonuc1 =
      parseFloat(this.params.data.SATIS) +
      parseFloat(this.params.data.SATSIP) +
      DepoAdt;

    Sonuc2 =
      parseFloat(this.params.data.SATALSIP) +
      parseFloat(this.params.data.QDEPOT);

    this.sonuc = Sonuc1 - Sonuc2;
    this.$root.$emit("setSonucData", this.params.rowIndex, this.sonuc);
  }
};
</script>
